/* A church's status, as a pill.
 *
 * One component rather than a colour lookup at each call site: the list, the
 * detail header and the requests queue all show status, and three copies drift
 * the moment a fifth state appears.
 *
 * `awaiting_admin` is a warning rather than neutral grey on purpose — a church
 * nobody has claimed is unfinished work, not a settled state.
 */
import type { ChurchStatus } from '@/types/api'

const STYLES: Record<ChurchStatus, string> = {
  active: 'bg-success-soft text-success-ink',
  on_hold: 'bg-warning-soft text-warning-ink',
  awaiting_admin: 'bg-warning-soft text-warning-ink',
  deleted: 'bg-danger-soft text-danger',
}

/* The client's own wording, from their specification. "Churches on Hold" reads
   oddly beside a single church, so the pill says "On hold" and the tab that
   filters by it carries their phrasing. */
const LABELS: Record<ChurchStatus, string> = {
  active: 'Active',
  on_hold: 'On hold',
  awaiting_admin: 'Awaiting admin',
  deleted: 'Deleted',
}

export function StatusPill({ status }: { status: ChurchStatus }) {
  return (
    <span
      className={
        'inline-flex items-center rounded-pill px-s3 py-0.5 text-sm font-semibold ' +
        STYLES[status]
      }
    >
      {LABELS[status]}
    </span>
  )
}
